import React from 'react';
import './About.scss';

const values = [
  {
    title: 'Innovation',
    description: 'We constantly push boundaries to bring cutting-edge solutions to our customers.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
      </svg>
    ),
    color: '#F59E0B',
  },
  {
    title: 'Accessibility',
    description: 'Powerful tools should be accessible to businesses of all sizes, not just enterprises.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    color: '#6366F1',
  },
  {
    title: 'Reliability',
    description: 'Your business depends on us. We maintain 99.9% uptime and enterprise-grade security.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        <path d="m9 12 2 2 4-4"/>
      </svg>
    ),
    color: '#10B981',
  },
  {
    title: 'Customer First',
    description: 'Every feature we build starts with understanding our customers\' real needs.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
      </svg>
    ),
    color: '#EC4899',
  },
];


export const About: React.FC = () => {
  return (
    <div className="about-page">
      <div className="hero-section glass-card">
        <h1 className="page-title">About FLVR SOFT</h1>
        <p className="hero-text">
          We believe that powerful business software shouldn't be limited to large enterprises. 
          Our mission is to empower small and medium businesses with modular, affordable, 
          and easy-to-use tools that drive growth and efficiency.
        </p>
        <div className="hero-stats">
          <div className="stat">
            <span className="stat-value">50K+</span>
            <span className="stat-label">Active Users</span>
          </div>
          <div className="stat">
            <span className="stat-value">50+</span>
            <span className="stat-label">Countries</span>
          </div>
          <div className="stat">
            <span className="stat-value">99.9%</span>
            <span className="stat-label">Uptime</span>
          </div>
          <div className="stat">
            <span className="stat-value">24/7</span>
            <span className="stat-label">Support</span>
          </div>
        </div>
      </div>

      <div className="values-section">
        <h2 className="section-title">Our Values</h2>
        <div className="values-grid">
          {values.map((value, index) => (
            <div key={index} className="value-card glass-card">
              <div 
                className="value-icon"
                style={{ background: `${value.color}20`, color: value.color }}
              >
                {value.icon}
              </div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Content from Flavuorsoft website */}
      <div className="company-info-section glass-card">
        <h2 className="section-title">About Us</h2>
        <p className="company-text">
          Flavuorsoft is your all-in-one business companion, revolutionizing small and medium-sized 
          enterprises with modular software solutions. Our comprehensive monthly packages include modules 
          like accounting, point of sale systems, website building, social media management, and AI-driven 
          tools. Elevate your business operations seamlessly with our efficient and affordable solutions.
        </p>
      </div>

      <div className="mission-vision-grid">
        <div className="glass-card mission-card">
          <h2 className="section-title">Our Mission</h2>
          <p>
            We are driven to empower businesses by providing them with user-friendly and adaptable 
            software solutions. We strive to enhance efficiency and affordability, enabling small and 
            medium-sized enterprises to reach their full growth potential.
          </p>
        </div>
        
        <div className="glass-card vision-card">
          <h2 className="section-title">Our Vision</h2>
          <p>
            Our vision is to become the go-to partner for small and medium-sized enterprises, offering 
            innovative and customizable software solutions. We aim to create a seamless digital experience 
            that helps businesses thrive in a rapidly evolving marketplace.
          </p>
        </div>
      </div>
    </div>
  );
};
